angular.module('study.ecrd.randomization', [
    'gettext',
    'randomization',
    'route',
]);
